// Generated by CoffeeScript 2.7.0
import Admin__AccessesController from './access.js';

Skylark.App.Controllers.register({Admin__AccessesController});
